import React from "react"
import { FormProvider, useForm } from "react-hook-form"
import { useToggle } from "../../../utils/Hooks"
import { Section } from "../../views/account/Shared"
import CarrotClient from "lib/carrot-api/index"
import { ChangePassword, ChangePasswordPreview } from "../../views/account/ChangePassword"
import Settings from "../../../utils/CarrotConfig"
import { HttpErrors } from "utils/HttpErrors"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
export const ChangePasswordContext = React.createContext()

export const ChangePasswordContainer = () => {
  const [isOpen, toggleIsOpen] = useToggle()
  const formMethods = useForm()
  const { handleSubmit, setError } = formMethods

  const onSubmit = handleSubmit(async (formData) => {
    try {
      await client.updatePassword(formData)
    } catch (error) {
      if (error.name === HttpErrors.BAD_REQUEST) {
        await handleBadRequest(error)
        return
      }
    }

    toggleIsOpen()
  })

  const handleBadRequest = async (error) => {
    const errors = JSON.parse(await error.response.text())
    Object.keys(errors).forEach((key) => {
      setError(key, { type: key, message: errors[key][0] })
    })
  }

  const changePasswordContext = {
    onSubmit,
    toggleIsOpen
  }

  return (
    <Section>
      <ChangePasswordContext.Provider value={changePasswordContext}>
        <FormProvider {...formMethods}>{isOpen ? <ChangePassword /> : <ChangePasswordPreview />}</FormProvider>
      </ChangePasswordContext.Provider>
    </Section>
  )
}
